import React, { useState, useCallback } from 'react';

import { useWindowSizeDebounced } from '../../../hooks/useWindowSize';

import { TooltipContainerDiv } from './styles';

export default function TooltipContainer({ children, light, width }) {
  const [isOutside, setIsOutside] = useState('');
  const { width: windowWidth } = useWindowSizeDebounced();

  const tooltipRef = useCallback(
    (node) => {
      if (node !== null) {
        const { x, width } = node.getBoundingClientRect();
        if (x < 0 && !isOutside) {
          setIsOutside('left');
        } else if (x + width > windowWidth && !isOutside) {
          setIsOutside('right');
        }
      }
    },
    [isOutside, windowWidth]
  );

  return (
    <TooltipContainerDiv width={width} light={light} ref={tooltipRef} isOutside={isOutside}>
      {children}
    </TooltipContainerDiv>
  );
}
